import type { TextTone } from './Text';
import { SectionTitle } from './Text';

/** "TODAY", "REWARD REQUESTS", "MONDAY": 12/700 uppercase, muted on the neutral body. */
export function SectionLabel({ children, tone = 'muted' }: { children: string; tone?: TextTone }) {
  return <SectionTitle tone={tone}>{children}</SectionTitle>;
}
